export default __webpack_public_path__ + "static/media/Two Buttons.edb78ac1.svg";